import { render, staticRenderFns } from "./ClientSolutionDetails.vue?vue&type=template&id=dba8bafe&scoped=true&"
import script from "./ClientSolutionDetails.vue?vue&type=script&lang=js&"
export * from "./ClientSolutionDetails.vue?vue&type=script&lang=js&"
import style0 from "./ClientSolutionDetails.vue?vue&type=style&index=0&id=dba8bafe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba8bafe",
  null
  
)

export default component.exports